import React, { useState } from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { commonStyles } from "../commonStyles";

type TooltipProps = {
  content: string;
  placement?: "top" | "right" | "bottom" | "left";
  iconSize?: "small" | "medium" | "large";
};

const Tooltip = ({
  content,
  placement = "top",
  iconSize = "small",
}: TooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => setShowTooltip(true);
  const handleMouseLeave = () => setShowTooltip(false);
  const handleFocus = () => setShowTooltip(true);
  const handleBlur = () => setShowTooltip(false);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      setShowTooltip(!showTooltip);
    }
  };

  const getTooltipPosition = () => {
    switch (placement) {
      case "top":
        return {
          bottom: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          marginBottom: "10px",
        };
      case "right":
        return {
          left: "100%",
          top: "50%",
          transform: "translateY(-50%)",
          marginLeft: "10px",
        };
      case "bottom":
        return {
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          marginTop: "10px",
        };
      case "left":
        return {
          right: "100%",
          top: "50%",
          transform: "translateY(-50%)",
          marginRight: "10px",
        };
      default:
        return {
          bottom: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          marginBottom: "10px",
        };
    }
  };

  return (
    <div className="relative inline-flex items-center ml-1">
      <div
        role="button"
        tabIndex={0}
        aria-label="Help information"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className="cursor-help"
      >
        <HelpOutlineIcon
          sx={{
            color: "#6B7280",
            fontSize:
              iconSize === "small" ? 16 : iconSize === "medium" ? 20 : 24,
          }}
        />
      </div>

      {showTooltip && (
        <div
          style={{
            ...getTooltipPosition(),
            position: "absolute",
            zIndex: 50,
            width: "250px",
            padding: "8px 12px",
            backgroundColor: "white",
            color: "#374151",
            borderRadius: "6px",
            fontSize: commonStyles.fontSizes.small,
            boxShadow:
              "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            border: "1px solid #E5E7EB",
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
